module.exports = __webpack_public_path__ + "static-portal/img/58-1.e343f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/58-1.jpg
// module id = ocrP
// module chunks = 4